export default __webpack_public_path__ + "static/media/frogs-dance.599494dd.jpeg";